"use strict";
module.exports = {
    'v1.job.createJob': 'cron',
    'v1.job.startJob': 'cron',
    'v1.job.resetJob': 'cron',
    'v1.job.stopJob': 'cron',
    'v1.job.runStandaloneJob': 'cron',
    'v1.job.activate': 'cron',
    'v1.job.deactivate': 'cron',
    'v1.job.upsert': 'cron',
    'v1.job.upsertWhenEmpty': 'cron',
    'v1.job.updateWhenEmpty': 'cron',
    'v1.job.update': 'cron',
    'v1.cronEventsource.cleanUpOldEvents': 'cron',
    'v1.cronEventsource.undoEvent': 'cron',
    'v1.cronEventsource.reEmit': 'cron',
};
